import { probeSupport } from '../depth/session'

/**
 * The pre-session screen. Its only job is to be honest about why AR will not
 * start, because "Start AR" that does nothing is the least debuggable failure
 * this demo can have.
 */

export interface Gate {
  readonly element: HTMLElement
  /** Shows a failure and re-arms the button. */
  fail(message: string): void
  remove(): void
}

export function createGate(onStart: () => Promise<void>): Gate {
  const gate = document.createElement('div')
  gate.className = 'demo-gate'

  const title = document.createElement('h1')
  title.textContent = 'WebXR Depth Demo'

  const body = document.createElement('p')
  body.textContent =
    'Virtual boxes standing on live-sensed real geometry. Needs Chrome on Android with ARCore.'

  const button = document.createElement('button')
  button.type = 'button'
  button.textContent = 'Checking…'
  button.disabled = true

  const note = document.createElement('p')
  note.className = 'demo-gate-note'

  gate.append(title, body, button, note)

  const fail = (message: string): void => {
    button.disabled = false
    button.textContent = 'Start AR'
    note.dataset['tone'] = 'bad'
    note.textContent = message
  }

  void probeSupport().then((state) => {
    if (state.kind === 'blocked') {
      button.textContent = 'Unavailable'
      note.dataset['tone'] = 'bad'
      note.textContent = state.reason
      return
    }
    button.textContent = 'Start AR'
    button.disabled = false
  })

  button.addEventListener('click', () => {
    button.disabled = true
    button.textContent = 'Starting…'
    onStart().catch((error: unknown) => {
      fail(error instanceof Error ? error.message : String(error))
    })
  })

  return {
    element: gate,
    fail,
    remove: () => gate.remove(),
  }
}
